import { render, staticRenderFns } from "./CategoriesModuleComponent.vue?vue&type=template&id=981717ec&scoped=true"
import script from "./CategoriesModuleComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./CategoriesModuleComponent.vue?vue&type=style&index=0&id=981717ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981717ec",
  null
  
)

export default component.exports